import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingComponent } from './landing/landing.component';
import { HeaderComponent } from './header/header.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SectionComponent } from './section/section.component';
import { TrackingComponent } from './tracking/tracking.component';
import { FindABranchComponent } from './find-a-branch/find-a-branch.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [

    // sample later change 
    {
        path: "",
        component: HomeComponent
    },
    {
        path: "home",
        component: HomeComponent
    },
    {
        path: "landing",
        component: LandingComponent
    },
    {
        path: "header",
        component: HeaderComponent
    },
    {
        path: "about-us",
        component: AboutUsComponent
    },
    {
        path: "section",
        component: SectionComponent
    },
    {
        path: "tracking",
        component: TrackingComponent
    },
    {
        path: "find-a-branch",
        component: FindABranchComponent
    },
    {
        path: "contact-us",
        component: ContactUsComponent
    },
    // { path: "", redirectTo: "/landing", pathMatch: "full" }

    // { path: "**", redirectTo: "/landing" }
    // { path: "**", redirectTo: "/landing", pathMatch: "full" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload'
    })],
    exports: [RouterModule]
})

export class AppRoutingModule { }



